import AsyncStorage from '@react-native-async-storage/async-storage';

export const SOCIAL_BANNER_PENDING_KEY = 'pending_social_banner_id';

let pendingSocialBannerIdMemory = null;

export function extractSocialBannerIdFromUrl(url) {
  if (!url) return null;
  const raw = String(url);
  const pathMatch = raw.match(/\/social\/([^/?#]+)/);
  if (pathMatch?.[1]) {
    return decodeURIComponent(pathMatch[1]).trim() || null;
  }
  try {
    const parsed = new URL(raw, 'https://local-club.zoolyfe.id');
    const fromQuery = parsed.searchParams.get('social') || parsed.searchParams.get('social_banner');
    return fromQuery ? String(fromQuery).trim() : null;
  } catch (e) {
    return null;
  }
}

export function peekPendingSocialBannerId() {
  return pendingSocialBannerIdMemory;
}

export function rememberPendingSocialBannerId(id) {
  pendingSocialBannerIdMemory = id ? String(id).trim() : null;
  return pendingSocialBannerIdMemory;
}

export async function hydratePendingSocialBannerId() {
  if (pendingSocialBannerIdMemory) return pendingSocialBannerIdMemory;
  const stored = await AsyncStorage.getItem(SOCIAL_BANNER_PENDING_KEY);
  pendingSocialBannerIdMemory = stored ? String(stored).trim() : null;
  return pendingSocialBannerIdMemory;
}

export async function persistSocialBannerIdFromUrl(url) {
  const id = extractSocialBannerIdFromUrl(url);
  if (!id) return null;
  rememberPendingSocialBannerId(id);
  await AsyncStorage.setItem(SOCIAL_BANNER_PENDING_KEY, id);
  return id;
}

export async function consumePendingSocialBannerId() {
  const id = pendingSocialBannerIdMemory || (await AsyncStorage.getItem(SOCIAL_BANNER_PENDING_KEY));
  pendingSocialBannerIdMemory = null;
  if (id) {
    await AsyncStorage.removeItem(SOCIAL_BANNER_PENDING_KEY);
  }
  return id || null;
}
